import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { GlobalConstants } from '../common/global';

@Injectable({
  providedIn: 'root'
})

export class ProfileService {
  private transactions: any[] | null = null;
  private transaction: any | null = null;
  private subsribersTickets: any[] | null = null;
  private subscribersTicketsInFlight$: Observable<any[]> | null = null;
  private membershipsCache: any[] | null = null;
  private membershipsInFlight$: Observable<any[]> | null = null;

  constructor(private readonly http: HttpClient) {}

  getTransactions(): Observable<any[]> {
    if (this.transactions) {
      return of(this.transactions);
    } else {
      return this.http.get<any[]>(`${environment.apiUrl}/conn/${environment.connId}/v1/user/transactions`, {
        headers: GlobalConstants.headersCentral.headers
      }).pipe(
        tap((data) => this.transactions = data)
      );
    }
  }

  getTransaction(transId: any, transactionType: string): Observable<{ success: boolean, data: string }> {
    if (this.transaction && transId === this.transaction?.transId && transactionType === this.transaction?.transactionType) {
      return of(this.transaction);
    } else {
      return this.http.get<{ success: boolean, data: string }>(`${environment.apiUrl}/conn/${environment.connId}/v1/user/transactions/${transId}/${transactionType}`, {
        headers: GlobalConstants.headersCentral.headers
      }).pipe(
        tap((data) => {
          this.transaction = data;
          this.transaction.transId = transId;
          this.transaction.transactionType = transactionType;
        })
      );
    }
  }

  getMemberships(initialState: boolean): Observable<any[]> {
    if (this.membershipsCache && initialState) {
      return of(this.membershipsCache);
    }

    if (this.membershipsInFlight$ && initialState) {
      return this.membershipsInFlight$;
    }

    this.membershipsInFlight$ = this.http
      .get<any[]>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/list`, { headers: GlobalConstants.headersCentral.headers })
      .pipe(
        tap(data => { this.membershipsCache = data; }),
        shareReplay({ bufferSize: 1, refCount: true })
      );

    return this.membershipsInFlight$;
  }

  getSubsribersTickets(initialState: boolean): Observable<any[]> {
    if(this.subsribersTickets && initialState) {
      return of(this.subsribersTickets);
    }
    
    if (this.subscribersTicketsInFlight$ && initialState) {
      return this.subscribersTicketsInFlight$;
    }
    
    this.subscribersTicketsInFlight$ = this.http.get<any[]>(`${environment.apiUrl}/conn/${environment.connId}/v1/user/transactionsSubscriber/list`, {
      headers: GlobalConstants.headersCentral.headers
    }).pipe(
      tap((data) => this.subsribersTickets = data),
      shareReplay({ bufferSize: 1, refCount: true })
    );
    
    return this.subscribersTicketsInFlight$;
  }   

  getTransactionAndOpenPdf(transID: string, transactionType: string, loader?: HTMLElement) {
    if (loader) loader.style.display = "flex";
    this.getTransaction(transID, transactionType).subscribe({
      next: (Response) => {
        if (!Response.data) {
          if (loader) loader.style.display = "none";
          return;
        }

        let response: any = Response;
        const ticketPdf = "data:application/pdf;base64," + response.data;
        const byteArray = new Uint8Array(atob(response.data).split('').map(char => char.charCodeAt(0)));
        let blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);

        let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        if (isSafari) {
          const fileName = 'ulaznica.pdf';
          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = fileName;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }

        if (loader) loader.style.display = "none";
      },
      error: (error: any) => {
        if (loader) loader.style.display = "none";
      }
    });
  }
}